import { render } from "./InviteEmployee.vue?vue&type=template&id=873c8dde&scoped=true"
import script from "./InviteEmployee.vue?vue&type=script&lang=js"
export * from "./InviteEmployee.vue?vue&type=script&lang=js"

import "./InviteEmployee.vue?vue&type=style&index=0&id=873c8dde&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873c8dde"]])

export default __exports__